export interface IDocumentInfoMessage {
  type: DocumentMessageTypes;
  message: string;
}

export interface IDocumentErrorMessage {
  type: DocumentMessageTypes;
  message: string;
  errors: IDocumentInfoErrorType[];
}

export interface IInfoMessageParams {
  message?: string;
}

export interface IErrorMessageParams {
  message?: string;
  errors?: IDocumentInfoErrorType[];
}

export enum DocumentMessageTypes {
  INFO = 'info',
  ERROR = 'error',
}

export interface IDocumentInfoErrorType {
  title: string;
  description: string;
  origin: string;
  showOrigin?: boolean;
}
